import axios from 'axios';
import { httpClient } from '@/api/httpClient';
import {
  mapPaginatedResource,
  type PaginatedApiResource,
  type PaginatedResult,
} from '@/api/pagination.types';
import {
  mapApiResourceToClientAnnouncement,
  type ClientAnnouncement,
  type ClientAnnouncementApiResource,
} from './announcementsApi.types';

export async function fetchOwnAnnouncements(
  page: number,
  pageSize: number
): Promise<PaginatedResult<ClientAnnouncement>> {
  const response = await httpClient.get<PaginatedApiResource<ClientAnnouncementApiResource>>(
    '/me/announcements',
    { params: { page, page_size: pageSize } }
  );
  return mapPaginatedResource(response.data, mapApiResourceToClientAnnouncement);
}

export async function fetchOwnAnnouncementById(
  announcementId: string
): Promise<ClientAnnouncement | null> {
  try {
    const response = await httpClient.get<ClientAnnouncementApiResource>(
      '/me/announcements/' + announcementId
    );
    return mapApiResourceToClientAnnouncement(response.data);
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error.response !== undefined &&
      error.response.status === 404
    ) {
      return null;
    }
    throw error;
  }
}
